// import InviteCard from './daily-components/invite-card'
import { TasksHosts } from './task-host'
import { TasksSpectators } from './task-spectator'

export function DailyTask() {
  return (
    <div className="flex flex-col items-center justify-between w-full gap-5 mt-4">
      {/* <InviteCard /> */}

      <div className="w-full bg-white rounded-2xl p-3">
        <TasksSpectators />
        <TasksHosts />
      </div>
    </div>
  )
}

export function DailyTasks() {
  return <DailyTask />
}
